import MailingPage from '@/pages/mailing/layout'
import MailingIndexPage from '@/pages/mailing/index'
import MailingCreatePage from '@/pages/mailing/create'

const routes = {
	path: '/mailing',
	component: MailingPage,
	meta: {title: 'Рассылки', breadcrumb: 'Рассылки'},
	children: [
		{
			path: '',
			component: MailingIndexPage,
			meta: {title: 'Рассылки'}
		},
		{
			path: 'create/:id',
			component: MailingCreatePage,
			meta: {title: 'Создание письма', breadcrumb: 'Создание письма'}
		}
	]
}

export default {
	routes
}



// WEBPACK FOOTER //
// ./src/routes/mailing.js